// components/Layout/ChangePasswordModal.jsx
import React, { useState } from 'react';
import { apiClient, API_ENDPOINTS } from '../../services/api';
import './ChangePasswordModal.css';

const ChangePasswordModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    new_password_confirmation: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Валидация
    if (formData.new_password !== formData.new_password_confirmation) {
      setError('Новый пароль и подтверждение не совпадают');
      return;
    }
    
    if (formData.new_password.length < 6) {
      setError('Новый пароль должен содержать минимум 6 символов');
      return;
    }
    
    setLoading(true);
    setError(null);
    
    try {
      await apiClient.put(API_ENDPOINTS.USER_PASSWORD, {
        current_password: formData.current_password,
        new_password: formData.new_password,
        new_password_confirmation: formData.new_password_confirmation
      });
      
      setSuccess(true);
      setFormData({
        current_password: '',
        new_password: '',
        new_password_confirmation: ''
      });
      
      // Закрываем модальное окно через 2 секунды после успеха
      setTimeout(() => {
        if (onSuccess) onSuccess();
        onClose();
        setSuccess(false);
      }, 2000);
      
    } catch (err) {
      console.error('Ошибка смены пароля:', err);
      if (err.status === 401) {
        setError('Неверный текущий пароль');
      } else if (err.status === 422) {
        setError(err.message || 'Ошибка валидации. Проверьте введенные данные.');
      } else {
        setError(err.message || 'Ошибка при смене пароля');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setFormData({
        current_password: '',
        new_password: '',
        new_password_confirmation: ''
      });
      setError(null);
      setSuccess(false);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Смена пароля</h3>
          <button className="modal-close" onClick={handleClose} disabled={loading}>
            &times;
          </button>
        </div>
        
        {success ? (
          <div className="modal-body">
            <div className="success-message">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <p>Пароль успешно изменен!</p>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="password-form">
            <div className="modal-body">
              {error && (
                <div className="error-message">
                  {error}
                </div>
              )}
              
              <div className="form-group">
                <label>Текущий пароль</label>
                <input
                  type="password"
                  name="current_password"
                  value={formData.current_password}
                  onChange={handleChange}
                  required
                  autoFocus
                  disabled={loading}
                />
              </div>
              
              <div className="form-group">
                <label>Новый пароль</label>
                <input
                  type="password"
                  name="new_password"
                  value={formData.new_password}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
                <small>Минимум 6 символов</small>
              </div>
              
              <div className="form-group">
                <label>Подтверждение нового пароля</label>
                <input
                  type="password"
                  name="new_password_confirmation"
                  value={formData.new_password_confirmation}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>
            </div>
            
            <div className="modal-footer">
              <button type="button" className="btn-cancel" onClick={handleClose} disabled={loading}>
                Отмена
              </button>
              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner-small"></span>
                    Сохранение...
                  </>
                ) : (
                  'Сменить пароль'
                )}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ChangePasswordModal;